import { RemarkSection } from '@euler/app/components/order/summary/RemarkSection';
import { useOrderVoiceUrls } from '@euler/app/components/voice/useOrderVoiceUrls';
import { useVoiceFeatures } from '@euler/app/components/voice/useVoiceFeatures';
import { useUserLocalSettings } from '@euler/app/flows/settings/functions/useUserLocalSettings';
import { useTaskContext } from '@euler/app/flows/task/functions/TaskContext';
import { memo } from 'react';

/**
 * Task-detail flavored RemarkSection: pulls the remark text and orderNo
 * from the task context, fetches voice URLs, and gates auto-play on the
 * store's voice-synthesis flag + `autoPlayOrderRemarkVoice` config + the
 * per-user opt-out. Both the mobile and iPad layouts render this component
 * to avoid duplicating the wiring at each call site.
 */
export const WiredRemarkSection = memo(() => {
  const { detail, storeConfiguration } = useTaskContext();
  const { isVoiceSynthesisEnabled } = useVoiceFeatures();
  const voiceUrls = useOrderVoiceUrls(detail.basicInfo.orderNo);
  const [userSettings] = useUserLocalSettings();
  const autoPlay =
    isVoiceSynthesisEnabled &&
    Boolean(storeConfiguration.app?.autoPlayOrderRemarkVoice) &&
    !userSettings?.disableAutoPlayOrderRemarkVoice;

  return (
    <RemarkSection
      remark={detail.basicInfo.remark}
      voiceUrl={voiceUrls?.remarkVoiceUrl}
      autoPlay={autoPlay}
    />
  );
});
WiredRemarkSection.displayName = 'WiredRemarkSection';
